'use client';

import type {
  ProductDetailData,
  VariantsEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { Heading } from '../../ui/heading';
import { Paragraph } from '../../ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { normalizeProductDescriptionHtml } from '@/utils/product-description';

export function ProductTabsDescription({
  product,
  selectedVariant,
}: {
  product: ProductDetailData;
  selectedVariant?: VariantsEntity;
}) {
  const description = normalizeProductDescriptionHtml(
    selectedVariant?.description || product.description,
  );

  return (
    <div className="flex w-full flex-col items-center justify-center gap-6 sm:gap-8">
      <Heading title="Popis produktu" tag="h2" styleAs="h4" center />
      <Paragraph
        className={cn('ea-generic-formatting', 'w-full')}
        color="muted-foreground"
        innerHtml={description}
      />
    </div>
  );
}
